<adaa-auth-layout>
    <form [formGroup]="loginForm" (ngSubmit)="submit()">
        <div class="adaa-auth-title">{{ "login.welcome_portal" | translate }}</div>

        <div class="adaa-auth-field">
            <adaa-form-input
                controlName="email"
                formControlName="email"
                inputType="email"
                [required]="true"
                [placeholder]="'common.form.label.email' | translate"
                [invalid]="
                    loginForm.get('password')?.dirty && (loginForm.get('email')?.errors?.['required'] || loginForm.get('email')?.errors?.['email'])
                "
            />
        </div>

        <div class="adaa-auth-field adaa-auth-field--password">
            <adaa-form-input
                controlName="password"
                formControlName="password"
                [required]="true"
                [placeholder]="'common.form.label.password' | translate"
                [inputType]="showPassword() ? 'text' : 'password'"
                [invalid]="loginForm.get('password')?.dirty && loginForm.get('password')?.errors?.['required']"
            />
            <button type="button" class="adaa-auth-eye" (click)="showPassword.set(!showPassword())">
                <i class="fa-solid" [class.fa-eye-slash]="showPassword()" [class.fa-eye]="!showPassword()"></i>
            </button>
        </div>

        <div class="adaa-auth-forgot">
            <a role="button" routerLink="/forget-password">{{ "login.forgot" | translate }}</a>
        </div>

        <button type="submit" class="adaa-auth-btn adaa-auth-btn-primary">{{ "login.login" | translate }}</button>

        @if (showUaePass) {
            <h6 class="adaa-auth-or" [class.rtl-label]="isArabic()">{{ "login.or" | translate }}</h6>
            <img
                class="adaa-auth-uae-img"
                role="button"
                (click)="loginUaePass()"
                [src]="isArabic() ? 'assets/images/uae_pass_buttons/login_arabic.png' : 'assets/images/uae_pass_buttons/login_english.png'"
                [alt]="'login.log_in_with_uae_pass' | translate"
            />
        }
    </form>
</adaa-auth-layout>
